import { useState, useEffect, useRef, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Container, Nav } from 'react-bootstrap';
import { ClipLoader } from "react-spinners";
import axiosInstance from '../api/axiosInstance';
import { hospitalEmergency } from '../api';
import { 
    FaRegHospital, 
    FaPhoneAlt, 
    FaMapMarkerAlt, 
    FaBed, 
    FaUserMd, 
    FaAmbulance, 
    FaClock, 
    FaExclamationCircle 
} from "react-icons/fa";

const Hospital = () => {
    const hospital = useSelector((state) => state.hospital);
    const privateData = useSelector((state) => state.privateData);
    let [emergencyInfoState, setEmergencyInfoState] = useState(null);
    let [map, setMap] = useState(null); // 카카오 맵 객체를 상태로 관리
    // eslint-disable-next-line no-unused-vars
    let [hpIdState, setHpIdState] = useState('');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('emergencyInfo');
    const emergencyInfoRef = useRef(null);

    const fnObj = useMemo(() => ({
        titleList: {
            emergencyTab: {
                dutyName: '병원명',
                dutyTel3: '응급실 직통연락처',
                hvidate: '업데이트 날짜',
                hvec: '응급실',
                hvoc: '수술실',
                hvcc: '신경중환자',
                hvncc: '신생중환자',
                hvccc: '흉부중환자',
                hvicc: '일반중환자',
                hv2: '내과중환자실',
                hv3: '외과중환자실',
                hv4: '외과입원실(정형외과)',
                hv6: '신경외과중환자실',
                hv8: '화상중환자',
                hv9: '외상중환자',
                hvgc: '입원실',
                hvamyn: '구급차가용여부',
                hv7: '약물중환자치료',
                hv5: '신경과입원실',
                hv10: 'VENTI(소아)',
                hvdnm: '당직의'
            },
            dissTab: {
                MKioskTy28: '응급실',
                MKioskTy1: '[재관류중재술] 심근경색',
                MKioskTy2: '[재관류중재술] 뇌경색',
                MKioskTy3: '[뇌출혈수술] 거미막하출혈',
                MKioskTy4: '[뇌출혈수술] 거미막하출혈 외',
                MKioskTy5: '[대동맥응급] 흉부',
                MKioskTy6: '[대동맥응급] 복부',
                MKioskTy7: '[담낭담관질환] 담낭질환',
                MKioskTy8: '[담낭담관질환] 담도포함질환',
                MKioskTy9: '[복부응급수술] 비외상',
                MKioskTy10: '[장중첩/폐색] 영유아',
                MKioskTy11: '[응급내시경] 성인 위장관',
                MKioskTy12: '[응급내시경] 영유아 위장관',
                MKioskTy13: '[응급내시경] 성인 기관지',
                MKioskTy14: '[응급내시경] 영유아 기관지',
                MKioskTy15: '[저출생체중아] 집중치료',
                MKioskTy16: '[산부인과응급] 분만',
                MKioskTy17: '[산부인과응급] 산과수술',
                MKioskTy18: '[산부인과응급] 부인과수술',
                MKioskTy19: '[중증화상] 전문치료',
                MKioskTy20: '[사지접합] 수족지접합',
                MKioskTy21: '[사지접합] 수족지접합 외',
                MKioskTy22: '[응급투석] HD',
                MKioskTy23: '[응급투석] CRRT',
                MKioskTy24: '[정신과적응급] 폐쇄병동입원',
                MKioskTy25: '[안과적수술] 응급',
                MKioskTy26: '[영상의학혈관중재] 성인',
                MKioskTy27: '[영상의학혈관중재] 영유아'
            },
            hospitalTab: {
                dutyAddr: '주소',
                dutyTel1: '대표전화',
                dutyHayn: '입원실가용여부(1/2)',
                dutyHano: '병상수',
                dutyMapimg: '간이약도',
                dutyEryn: '응급실운영여부(1/2)',
                dutyTime1s: '월요일 시작시간',
                dutyTime1c: '월요일 종료시간',
                dutyTime2s: '화요일 시작시간',
                dutyTime2c: '화요일 종료시간',
                dutyTime3s: '수요일 시작시간',
                dutyTime3c: '수요일 종료시간',
                dutyTime4s: '목요일 시작시간',
                dutyTime4c: '목요일 종료시간',
                dutyTime5s: '금요일 시작시간',
                dutyTime5c: '금요일 종료시간',
                dutyTime6s: '토요일 시작시간',
                dutyTime6c: '토요일 종료시간',
                dutyTime7s: '일요일 시작시간',
                dutyTime7c: '일요일 종료시간',
                dutyTime8s: '공휴일 시작시간',
                dutyTime8c: '공휴일 종료시간'
            }
        },
        isShowTab: [false, false, false, false, false],
        hpId: "",
        seoulDistricts: [
            "강남구", "강동구", "강북구", "강서구", "관악구", "광진구", "구로구", "금천구",
            "노원구", "도봉구", "동대문구", "동작구", "마포구", "서대문구", "서초구", "성동구",
            "성북구", "송파구", "양천구", "영등포구", "용산구", "은평구", "종로구", "중구", "중랑구"
        ],
        busanDistricts: [
            "강서구", "금정구", "기장군", "남구", "동구", "동래구", "부산진구", "북구",
            "사상구", "사하구", "서구", "수영구", "연제구", "영도구", "중구", "해운대구"
        ],
        daeguDistricts: [
            "군위군", "남구", "달서구", "달성군", "동구", "북구", "서구", "수성구", "중구"
        ],
        incheonDistricts: [
            "강화군", "계양구", "남동구", "동구", "미추홀구", "부평구", "서구",
            "연수구", "옹진군", "중구"
        ],
        gwangjuDistricts: ["광산구", "남구", "동구", "북구", "서구"],
        daejeonDistricts: ["대덕구", "동구", "서구", "유성구", "중구"],
        ulsanDistricts: ["남구", "동구", "북구", "울주군", "중구"],
        sejongDistricts: ["세종특별자치시"],
        gyeonggiDistricts: [
            "가평군", "고양시 덕양구", "고양시 일산동구", "고양시 일산서구", "과천시",
            "광명시", "광주시", "구리시", "군포시", "김포시", "남양주시", "동두천시",
            "부천시", "성남시 분당구", "성남시 수정구", "성남시 중원구", "수원시 권선구",
            "수원시 영통구", "수원시 장안구", "수원시 팔달구", "시흥시", "안산시 단원구",
            "안산시 상록구", "안성시", "안양시 동안구", "안양시 만안구", "양주시",
            "양평군", "여주시", "연천군", "오산시", "용인시 기흥구", "용인시 수지구",
            "용인시 처인구", "의왕시", "의정부시", "이천시", "파주시", "평택시",
            "포천시", "하남시", "화성시"
        ],
        gangwonDistricts: [
            "강릉시", "고성군", "동해시", "삼척시", "속초시", "양구군", "양양군", "영월군",
            "원주시", "인제군", "정선군", "철원군", "춘천시", "태백시", "평창군", "홍천군",
            "화천군", "횡성군"
        ],
        chungbukDistricts: [
            "괴산군", "단양군", "보은군", "영동군", "옥천군", "음성군", "제천시",
            "증평군", "진천군", "청주시 상당구", "청주시 서원구", "청주시 청원구",
            "청주시 흥덕구", "충주시"
        ],
        chungnamDistricts: [
            "계룡시", "공주시", "금산군", "논산시", "당진시", "보령시", "부여군",
            "서산시", "서천군", "아산시", "예산군", "천안시 동남구", "천안시 서북구",
            "청양군", "태안군", "홍성군"
        ],
        jeonbukDistricts: [
            "고창군", "군산시", "김제시", "남원시", "무주군", "부안군", "순창군",
            "완주군", "익산시", "임실군", "장수군", "전주시 덕진구", "전주시 완산구",
            "정읍시", "진안군"
        ],
        jeonnamDistricts: [
            "강진군", "고흥군", "곡성군", "광양시", "구례군", "나주시", "담양군",
            "목포시", "무안군", "보성군", "순천시", "신안군", "여수시", "영광군",
            "영암군", "완도군", "장성군", "장흥군", "진도군", "함평군", "해남군",
            "화순군"
        ],
        gyeongbukDistricts: [
            "경산시", "경주시", "고령군", "구미시", "군위군", "김천시", "문경시",
            "봉화군", "상주시", "성주군", "안동시", "영덕군", "영양군", "영주시",
            "영천시", "예천군", "울릉군", "울진군", "의성군", "청도군", "청송군",
            "칠곡군", "포항시 남구", "포항시 북구"
        ],
        gyeongnamDistricts: [
            "거제시", "거창군", "고성군", "김해시", "남해군", "밀양시", "사천시",
            "산청군", "양산시", "의령군", "진주시", "창녕군", "창원시 마산합포구",
            "창원시 마산회원구", "창원시 성산구", "창원시 의창구", "창원시 진해구",
            "통영시", "하동군", "함안군", "함양군", "합천군"
        ],
        jejuDistricts: ["서귀포시", "제주시"],
        mapObj: {
            mapContainer: document.getElementById('map'),
            mapOption: {
                center: new window.kakao.maps.LatLng(37.56212, 126.94083), // 지도의 중심좌표
                level: 3 // 지도의 확대 레벨
            },
            map: null
        },
        getKakaoMapInit() {
            let mapContainer = fnObj.mapObj.mapContainer;
            let mapOption = fnObj.mapObj.mapOption;

            if (!map) {  // 맵이 생성되지 않았을 경우에만 초기화
                const newMap = new window.kakao.maps.Map(mapContainer, mapOption);
                newMap.setDraggable(true); // 드래그 가능
                newMap.setZoomable(true); // 줌인/줌아웃 가능

                setMap(newMap);  // 상태 업데이트
                fnObj.mapObj.map = newMap;  // 기존 fnObj에도 저장
            }
        },
        init() {
            fnObj.getKakaoMapInit();
        },
        getRegionSelect() {
            const selectedRegion = document.getElementById("region").value;
            const subRegion = document.getElementById("subRegion");

            // 초기화
            subRegion.innerHTML = ''; // 기존의 모든 옵션을 제거합니다.
            subRegion.innerHTML = '<option value="">구 선택</option>'; // 새로운 옵션을 추가합니다.
            subRegion.disabled = true; // 요소를 비활성화합니다.

            let districtsObj = [];

            if (selectedRegion === "서울") {
                districtsObj = fnObj.seoulDistricts;
            } else if (selectedRegion === "부산") {
                districtsObj = fnObj.busanDistricts;
            } else if (selectedRegion === "대구") {
                districtsObj = fnObj.daeguDistricts;
            } else if (selectedRegion === "인천") {
                districtsObj = fnObj.incheonDistricts;
            } else if (selectedRegion === "광주") {
                districtsObj = fnObj.gwangjuDistricts;
            } else if (selectedRegion === "대전") {
                districtsObj = fnObj.daejeonDistricts;
            } else if (selectedRegion === "울산") {
                districtsObj = fnObj.ulsanDistricts;
            } else if (selectedRegion === "세종") {
                districtsObj = fnObj.sejongDistricts;
            } else if (selectedRegion === "경기") {
                districtsObj = fnObj.gyeonggiDistricts;
            } else if (selectedRegion === "강원") {
                districtsObj = fnObj.gangwonDistricts;
            } else if (selectedRegion === "충북") {
                districtsObj = fnObj.chungbukDistricts;
            } else if (selectedRegion === "충남") {
                districtsObj = fnObj.chungnamDistricts;
            } else if (selectedRegion === "전북") {
                districtsObj = fnObj.jeonbukDistricts;
            } else if (selectedRegion === "전남") {
                districtsObj = fnObj.jeonnamDistricts;
            } else if (selectedRegion === "경북") {
                districtsObj = fnObj.gyeongbukDistricts;
            } else if (selectedRegion === "경남") {
                districtsObj = fnObj.gyeongnamDistricts;
            } else if (selectedRegion === "제주") {
                districtsObj = fnObj.jejuDistricts;
            }
            districtsObj.forEach((district) => {
                var option = document.createElement('option'); // 새로운 <option> 요소를 생성합니다.
                option.value = district; // option의 value 속성을 설정합니다.
                option.textContent = district; // option의 텍스트를 설정합니다.
                subRegion.appendChild(option); // <select> 요소에 <option>을 추가합니다.
            });

            subRegion.disabled = false;
        },
        getParseXMLToJSON(xmlString) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlString, "text/xml");

            const xmlToJson = (node) => {
                const obj = {};
                if (node.nodeType === 1) { // Element node
                    if (node.attributes.length > 0) {
                        obj["@attributes"] = {};
                        for (let attr of node.attributes) {
                            obj["@attributes"][attr.nodeName] = attr.nodeValue;
                        }
                    }
                } else if (node.nodeType === 3) { // Text node
                    return node.nodeValue.trim();
                }

                if (node.childNodes.length > 0) {
                    for (let child of node.childNodes) {
                        const nodeName = child.nodeName;
                        const jsonChild = xmlToJson(child);

                        if (jsonChild) {
                            if (obj[nodeName] === undefined) {
                                obj[nodeName] = jsonChild;
                            } else {
                                if (!Array.isArray(obj[nodeName])) {
                                    obj[nodeName] = [obj[nodeName]];
                                }
                                obj[nodeName].push(jsonChild);
                            }
                        }
                    }
                }
                return obj;
            };

            return { [xmlDoc.documentElement.nodeName]: xmlToJson(xmlDoc.documentElement) };
        },
        getSearch() {
            fnObj.isShowTab[0] = true;
            const region = document.getElementById("region").value;
            const subRegion = document.getElementById("subRegion").value;
            if (subRegion) {
                let hospitalList = [];
                (async () => {
                    setLoading(true);
                    try {
                        const response = await hospitalEmergency(region, subRegion, privateData.serviceKey);
                        let emergencyList = fnObj.getParseXMLToJSON(response).response.body.items.item;
                        if (!Array.isArray(emergencyList)) {
                            emergencyList = [emergencyList]; // 단일 객체라면 배열로 변환
                        }
                        const locationList = await Promise.all(
                            emergencyList.map((e, idx) =>
                                axiosInstance.get(`${hospital.hospitalUrl}?serviceKey=${privateData.serviceKey}&HPID=${e.hpid['#text']}`, {
                                    headers: {
                                        'Accept': 'application/xml',
                                    }
                                })
                            )
                        );

                        // 응답 데이터 처리                        
                        const detailDataList = locationList.map(res => fnObj.getParseXMLToJSON(res.data));

                        for (let detail of detailDataList) {
                            let wgsList = [parseFloat(detail.response.body.items.item.wgs84Lat['#text']), parseFloat(detail.response.body.items.item.wgs84Lon['#text'])];
                            let hospitalObj = {
                                hpId: detail.response.body.items.item.hpid,
                                wgsList: wgsList,
                                dutyName: detail.response.body.items.item.dutyName,
                                dutyTel3: detail.response.body.items.item.dutyTel3
                            }
                            hospitalList.push(hospitalObj);
                        }

                        fnObj.getKaKaoMap(hospitalList);

                    } catch (error) {
                        console.log(error);
                        alert('해당 지역은 조회되지 않습니다.');
                    }
                    setLoading(false);
                })();
            }
        },
        getKaKaoMap(hospitalList) { // 구 셀렉트박스 선택 시 병원 위치 지도 표출 이벤트 핸들러
            let pointList = [];
            let hospitalInfoList = [];
            for (let wgs of hospitalList) {
                pointList.push(new window.kakao.maps.LatLng(parseFloat(wgs.wgsList[0]), parseFloat(wgs.wgsList[1])));
                hospitalInfoList.push({ dutyName: wgs.dutyName['#text'], dutyTel3: wgs.dutyTel3['#text'] });
            }

            let bounds = new window.kakao.maps.LatLngBounds();

            let i, marker;
            for (i = 0; i < pointList.length; i++) {
                marker = new window.kakao.maps.Marker({ map: map, position: pointList[i], clickable: true });
                marker.setMap(map);

                let iwContent = `
                    <div style="padding: 10px; font-family: sans-serif; font-size: 13px; line-height: 1.4; min-width: 160px; max-width: 220px; border-radius: 8px;">
                        <div style="font-weight: 700; color: #1a202c; margin-bottom: 5px; font-size: 13px; word-break: keep-all;">
                            ${hospitalList[i].dutyName['#text']}
                        </div>
                        <div style="font-size: 12px; color: #3182ce; font-weight: 600;">
                            ☎ <a href="tel:${hospitalList[i].dutyTel3['#text']}" style="color: #3182ce; text-decoration: none;" target="_blank">${hospitalList[i].dutyTel3['#text']}</a>
                        </div>
                    </div>
                `;

                let iwPosition = new window.kakao.maps.LatLng(pointList[i].getLat(), pointList[i].getLng());
                let infowindow = new window.kakao.maps.InfoWindow({
                    position: iwPosition,
                    content: iwContent
                });

                infowindow.open(map, marker);
                bounds.extend(pointList[i]);
                fnObj.addKakaoMarker(pointList[i], hospitalList[i].hpId['#text'], marker);
                fnObj.hpId = hospitalList[i].hpId['#text'];
                setHpIdState(hospitalList[i].hpId['#text']);
                if (i === 0) {
                    fnObj.showTab("emergencyInfo");
                }
            }

            map.setBounds(bounds);
        },
        addKakaoMarker(position, hpId, marker) { // 마커 이벤트 핸들러
            window.kakao.maps.event.addListener(marker, 'click', function () { // 마커 클릭 시 하단 상세 탭 변경
                fnObj.hpId = hpId;
                setHpIdState(hpId);
                fnObj.showTab("emergencyInfo");
            });
        },
        showTab(tabId) { // 탭 클릭 이벤트 핸들러            
            setActiveTab(tabId);

            if (tabId === "emergencyInfo" || tabId === "dissInfo" || tabId === "hospitalInfo") {
                if (fnObj.hpId) {
                    (async () => {
                        try {
                            const response = await axiosInstance.get(`${hospital.hospitalUrl}?serviceKey=${privateData.serviceKey}&HPID=${fnObj.hpId}`, {
                                headers: {
                                    'Accept': 'application/xml',
                                }
                            });
                            let responseObj = fnObj.getParseXMLToJSON(response.data).response.body.items.item;
                            setEmergencyInfoState(responseObj);
                            emergencyInfoRef.current = responseObj;
                        } catch (error) {
                            console.log('출력 오류');
                        }
                    })();
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [hospital.hospitalEmergencyUrl, hospital.hospitalUrl, privateData.serviceKey, map]);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=252789b38c66bb62dc7212f1c1176ea0&libraries=services,clusterer,drawing`;
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
            fnObj.mapObj.mapContainer = document.getElementById("map");
            if (fnObj.mapObj.mapContainer) {
                fnObj.init();
            } else {
                console.error(" `#map` 요소를 찾을 수 없음.");
            }
        };

        return () => {
            document.head.removeChild(script);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fnObj]);

    const getValue = (key) => {
        if (!emergencyInfoState || !emergencyInfoState[key]) return '-';
        const valObj = emergencyInfoState[key];
        if (typeof valObj === 'object') {
            return valObj['#text'] || '-';
        }
        return valObj || '-';
    };

    const renderBedStatus = (val) => {
        const num = parseInt(val, 10);
        if (isNaN(num)) {
            return <span className="medical-badge medical-badge-gray">-</span>;
        }
        if (num > 0) {
            return <span className="medical-badge medical-badge-green">{num}석 가용</span>;
        } else if (num === 0) {
            return <span className="medical-badge medical-badge-red">만석</span>;
        } else {
            return <span className="medical-badge medical-badge-orange">{num}석 (대기)</span>;
        }
    };

    const renderCriticalStatus = (val) => {
        if (val === 'Y' || val === '가능') {
            return <span className="medical-badge medical-badge-green">수용 가능</span>;
        }
        if (val === 'N' || val === '불가능') {
            return <span className="medical-badge medical-badge-red">수용 불가</span>;
        }
        return <span className="medical-badge medical-badge-gray">정보 없음</span>;
    };

    const bedItems = [
        { key: 'hvec', label: '응급실', icon: <FaRegHospital /> },
        { key: 'hvoc', label: '수술실', icon: <FaBed /> },
        { key: 'hvgc', label: '일반입원실', icon: <FaBed /> },
        { key: 'hvicc', label: '일반중환자', icon: <FaBed /> },
        { key: 'hvcc', label: '신경중환자', icon: <FaBed /> },
        { key: 'hvncc', label: '신생중환자', icon: <FaBed /> },
        { key: 'hvccc', label: '흉부중환자', icon: <FaBed /> },
        { key: 'hv2', label: '내과중환자', icon: <FaBed /> },
        { key: 'hv3', label: '외과중환자', icon: <FaBed /> },
        { key: 'hv6', label: '신경외과중환자', icon: <FaBed /> },
        { key: 'hv8', label: '화상중환자', icon: <FaBed /> },
        { key: 'hv9', label: '외상중환자', icon: <FaBed /> },
        { key: 'hv7', label: '약물중환자', icon: <FaBed /> },
        { key: 'hv5', label: '신경과입원', icon: <FaBed /> },
        { key: 'hv4', label: '외과입원(정형)', icon: <FaBed /> },
        { key: 'hv10', label: '인공호흡기(소아)', icon: <FaBed /> },
    ];

    return (
        <div className="medical-wrapper">
            {
                loading && (
                    <div className="loading-overlay">
                        <div className="loading-spinner">
                            <ClipLoader color="#ffffff" size={50} />
                            <p className="mt-2">찾는중...</p>
                        </div>
                    </div>
                )
            }
            <Container>
                {/* 필터 카드 */}
                <div className="medical-filter-card d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <h4 className="m-0 fw-bold d-flex align-items-center gap-2">
                        <FaRegHospital className="text-primary" /> 응급실 정보 검색
                    </h4>
                    <div className="d-flex gap-2">
                        <Form.Select
                            id='region'
                            name='region'
                            aria-label="시 선택"
                            className="medical-select"
                            style={{ width: '140px' }}
                            onChange={fnObj.getRegionSelect}
                            defaultValue=""
                        >
                            <option value="">시 선택</option>
                            <option value="서울">서울</option>
                            <option value="부산">부산</option>
                            <option value="인천">인천</option>
                            <option value="대구">대구</option>
                            <option value="광주">광주</option>
                            <option value="세종">세종</option>
                            <option value="대전">대전</option>
                            <option value="울산">울산</option>
                            <option value="경기">경기</option>
                            <option value="강원">강원</option>
                            <option value="충북">충북</option>
                            <option value="충남">충남</option>
                            <option value="전북">전북</option>
                            <option value="전남">전남</option>
                            <option value="경북">경북</option>
                            <option value="경남">경남</option>
                            <option value="제주">제주</option>
                        </Form.Select>
                        <Form.Select
                            id='subRegion'
                            name='subRegion'
                            aria-label="구 선택"
                            className="medical-select"
                            style={{ width: '140px' }}
                            onChange={fnObj.getSearch}
                            defaultValue=""
                            disabled
                        >
                            <option value="">구 선택</option>
                        </Form.Select>
                    </div>
                </div>

                {/* 메인 2컬럼 그리드 */}
                <div className="medical-grid-layout">
                    {/* 카카오 지도 */}
                    <div id="map" className="medical-map-container"></div>

                    {/* 병원 상세 정보 패널 */}
                    <div className="medical-panel">
                        {emergencyInfoState ? (
                            <>
                                <div className="medical-panel-header">
                                    <h5 className="medical-panel-title">
                                        <FaRegHospital className="text-primary" />
                                        {getValue('dutyName')}
                                    </h5>
                                    <a href={`tel:${getValue('dutyTel3')}`} className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1 fw-bold rounded-pill">
                                        <FaPhoneAlt size={12} /> 응급실 전화
                                    </a>
                                </div>

                                <Nav justify className="medical-tabs px-3 mt-2">
                                    <Nav.Item>
                                        <Nav.Link 
                                            className={activeTab === 'emergencyInfo' ? 'active' : ''}
                                            onClick={() => fnObj.showTab('emergencyInfo')}
                                        >
                                            가용병상
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link 
                                            className={activeTab === 'dissInfo' ? 'active' : ''}
                                            onClick={() => fnObj.showTab('dissInfo')}
                                        >
                                            중증수용
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link 
                                            className={activeTab === 'hospitalInfo' ? 'active' : ''}
                                            onClick={() => fnObj.showTab('hospitalInfo')}
                                        >
                                            병원정보
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>

                                {/* 탭 콘텐츠 영역 */}
                                {activeTab === 'emergencyInfo' && (
                                    <div className="medical-panel-content medical-scrollbar">
                                        <div className="medical-detail-grid">
                                            {bedItems.map((item) => (
                                                <div className="medical-detail-card" key={item.key}>
                                                    <div className="medical-detail-label d-flex align-items-center justify-content-center gap-1">
                                                        {item.icon}
                                                        {item.label}
                                                    </div>
                                                    <div className="medical-detail-value mt-1">
                                                        {renderBedStatus(getValue(item.key))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="mt-3 p-3 bg-light rounded-3 d-flex flex-column gap-2" style={{ fontSize: '0.85rem' }}>
                                            <div className="d-flex justify-content-between border-bottom pb-1">
                                                <span className="text-muted"><FaUserMd className="me-1" /> 당직의:</span>
                                                <span className="fw-bold">{getValue('hvdnm')}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom pb-1">
                                                <span className="text-muted"><FaAmbulance className="me-1" /> 구급차가용여부:</span>
                                                <span className="fw-bold">{getValue('hvamyn') === 'Y' ? '가용' : '불가'}</span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <span className="text-muted"><FaClock className="me-1" /> 업데이트 날짜:</span>
                                                <span className="fw-bold">{getValue('hvidate')}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'dissInfo' && (
                                    <div className="medical-panel-content medical-scrollbar">
                                        <div className="medical-detail-grid">
                                            {Object.entries(fnObj.titleList.dissTab).map(([key, label]) => (
                                                <div className="medical-detail-card d-flex flex-column justify-content-between align-items-center" key={key} style={{ minHeight: '100px' }}>
                                                    <div className="medical-detail-label text-center" style={{ whiteSpace: 'normal', fontSize: '0.75rem', lineHeight: '1.3' }}>
                                                        {label}
                                                    </div>
                                                    <div className="mt-2 w-100 text-center">
                                                        {renderCriticalStatus(getValue(key))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'hospitalInfo' && (
                                    <div className="medical-panel-content medical-scrollbar">
                                        <div className="d-flex flex-column gap-3">
                                            <div className="p-3 bg-light rounded-3">
                                                <div className="text-muted mb-1" style={{ fontSize: '0.8rem' }}><FaMapMarkerAlt className="me-1" /> 주소</div>
                                                <div className="fw-bold">{getValue('dutyAddr')}</div>
                                            </div>
                                            <div className="p-3 bg-light rounded-3">
                                                <div className="text-muted mb-1" style={{ fontSize: '0.8rem' }}><FaPhoneAlt className="me-1" /> 대표전화</div>
                                                <div className="fw-bold">
                                                    <a href={`tel:${getValue('dutyTel1')}`} style={{ textDecoration: 'none', color: '#3182ce' }}>
                                                        {getValue('dutyTel1')}
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="p-3 bg-light rounded-3 d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="text-muted mb-1" style={{ fontSize: '0.8rem' }}><FaBed className="me-1" /> 병상 수</div>
                                                    <div className="fw-bold">{getValue('dutyHano')} 병상</div>
                                                </div>
                                                <div>
                                                    <div className="text-muted mb-1" style={{ fontSize: '0.8rem' }}>입원실 가용</div>
                                                    <div>
                                                        {getValue('dutyHayn') === '1' ? (
                                                            <span className="medical-badge medical-badge-green">가능</span>
                                                        ) : (
                                                            <span className="medical-badge medical-badge-red">불가</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-3 bg-light rounded-3">
                                                <div className="text-muted mb-2" style={{ fontSize: '0.8rem' }}><FaClock className="me-1" /> 요일별 시작/종료 시간</div>
                                                <div className="d-flex flex-column gap-1" style={{ fontSize: '0.85rem' }}>
                                                    <div className="d-flex justify-content-between border-bottom py-1"><span>월요일</span><span>{getValue('dutyTime1s')} ~ {getValue('dutyTime1c')}</span></div>
                                                    <div className="d-flex justify-content-between border-bottom py-1"><span>화요일</span><span>{getValue('dutyTime2s')} ~ {getValue('dutyTime2c')}</span></div>
                                                    <div className="d-flex justify-content-between border-bottom py-1"><span>수요일</span><span>{getValue('dutyTime3s')} ~ {getValue('dutyTime3c')}</span></div>
                                                    <div className="d-flex justify-content-between border-bottom py-1"><span>목요일</span><span>{getValue('dutyTime4s')} ~ {getValue('dutyTime4c')}</span></div>
                                                    <div className="d-flex justify-content-between border-bottom py-1"><span>금요일</span><span>{getValue('dutyTime5s')} ~ {getValue('dutyTime5c')}</span></div>
                                                    <div className="d-flex justify-content-between border-bottom py-1"><span>토요일</span><span>{getValue('dutyTime6s')} ~ {getValue('dutyTime6c')}</span></div>
                                                    <div className="d-flex justify-content-between border-bottom py-1"><span>일요일</span><span>{getValue('dutyTime7s')} ~ {getValue('dutyTime7c')}</span></div>
                                                    <div className="d-flex justify-content-between text-danger fw-semibold py-1"><span>공휴일</span><span>{getValue('dutyTime8s')} ~ {getValue('dutyTime8c')}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted p-4">
                                <FaExclamationCircle size={48} className="mb-3 text-secondary" style={{ opacity: 0.5 }} />
                                <h6 className="fw-bold">병원이 선택되지 않았습니다.</h6>
                                <p className="small text-center" style={{ maxWidth: '240px' }}>
                                    지역을 선택하고 검색된 지도의 마커를 클릭하면 상세 병원 정보를 볼 수 있습니다.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </Container>
        </div>
    );
}

export { Hospital };
